import { createContext, useContext } from "react";

import { IAllocationFormHelper } from "./AllocationFormHelper.types.ts";

export const AllocationFormContext = createContext<IAllocationFormHelper>(
  {} as IAllocationFormHelper
);

export const useAllocationFormContext = () => useContext(AllocationFormContext);
